<template>
  <div>
    <component :is="componentType"></component>
  </div>
</template>

<script>
export default {
  name: "Home",

  components: {
    PcHome: () => import("./Index.vue"), // PC端组件
    MobileHome: () => import("./Mobile/Index.vue"), // 移动端组件
  },

  computed: {
    componentType() {
      return this.$store.state.isMobile ? "MobileHome" : "PcHome";
    },
  },
};
</script>

<style scoped></style>
./Home.vue
